export default __webpack_public_path__ + "static/media/victor-evangelista.0a64b970.jpg";